export default __webpack_public_path__ + "static/media/mobile_step_3_Cn.82083fc0.jpg";